import React from 'react'
import { Link } from 'react-router-dom'

const Services = () => {
  return (
    <div class='service-div1'>
        <div class='service-div'>
            {/* <h1 class='service-h'>Services</h1> */}
        </div>
        <h1 class='service-h1'>Our Services</h1>
       <div class='container'>
            <div class='row mt-4'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                      <Link to={'/Annual'}> 
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                      </Link> 
                    </div>
                    <h5 class='about-service1 d-flex justify-content-center'>Annual Maintenance<br></br> Works</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <Link to={'/Hydrant'}>
                        <img src='./Images/img5.jpg' alt='' class='about-ser mt-5' />
                        </Link>
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Hydrant Works</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <Link>
                        <img src='./Images/img3.jpg' alt='' class='about-ser mt-5' />
                        </Link>
                    </div>
                    <h5 class='about-service1 d-flex justify-content-center'>Fire Alarm &<br></br> Security System Works</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <Link>
                        <img src='./Images/extin.jpg' alt='' class='about-ser mt-5' />
                        </Link>
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Plumbing Works</h5>
                </div>
            </div>
            <div class='row mt-4'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <Link>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                        </Link>
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>HVAC Works</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <Link>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                        </Link>
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Electrical Works</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <Link>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                        </Link>
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Alarm</h5>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <div class='d-flex justify-content-center'>
                        <Link>
                        <img src='./Images/service.jpg' alt='' class='about-ser mt-5' />
                        </Link>
                    </div>
                    <h5 class='about-service d-flex justify-content-center'>Fire Alarm</h5>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Services